/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 6/10/2023
 */

import React, { useEffect } from 'react'
import Intro from "../Components/aboutUs/intro";
import OurStory from "../Components/aboutUs/ourStroy"
import ContainerOne from "../Components/aboutUs/containerOne"
import ContainerTwo from "../Components/aboutUs/containerTwo"
import IntroVid from "../Components/aboutUs/introVid"
import CeoMsg from "../Components/aboutUs/ceoMsg"
import Vision from "../Components/aboutUs/vision"
import { Container } from '@mui/material';
import { isMobile } from 'react-device-detect';
import { Helmet } from 'react-helmet';

const aboutUs = () => {

    return (
      <>
        <Helmet>
          <title>About Us - Adelaide - Housekeeping | Home Cleaning | Office Cleaning in Adelaide - Australia | Domestic house cleaning | Office cleaning | Garden cleaning | Y-DIY | offers</title>
          <meta name="title" content="About Doneright housekeepers" />
          {/* OpenGraph data */}
          <meta property="og:title" content="About Doneright housekeepers" />
          <meta
            property="og:description" // SHOULD CHANGE
            content="Welcome to Doneright housekeepers, your trusted partner for immaculate cleaning services in Adelaide."
          />
          <meta property="og:type" content="website" />
          <meta
            property="og:image"
            content={`${process.env.REACT_APP_IMAGE_URL}DoneRight/HOME/doneRightLogo.png`}
          />
          <meta property="og:image:width" content="400" />
          <meta property="og:image:height" content="300" />
          <meta property="og:site_name" content="DoneRight Housekeepers" />
          <link rel="canonical" href={`${process.env.prodUrl}/aboutUs`} key="canonical" />
        </Helmet>
        <Container style={{ maxWidth: '1500px' }}>
          <div style={{marginTop:"20px",marginBottom:"10px"}}>
            <Intro />
          </div>
          <div style={{marginTop: isMobile? "20px": "100px",marginBottom:"10px"}}>
            <OurStory />
          </div>
          <div style={{marginTop:isMobile? "20px" :"100px",marginBottom:"10px"}}>
            <ContainerOne />
          </div>
          <div style={{marginTop:isMobile? "20px" :"100px",marginBottom:"10px"}}>
            <ContainerTwo />
          </div>
          {/* <div style={{marginTop:"100px",marginBottom:"10px"}}>
            <IntroVid />
          </div> */}
          <div style={{marginTop:isMobile? "20px" :"100px",marginBottom:"50px"}}>
            <Vision />
          </div>
        </Container>
      </>
    );
  }
  

export default aboutUs;


